export enum PhonePlansRoutePathsEnum {
  PHONE_PLAN = 'phone-plans/:phonePlanId',
  PHONE_PLANS = 'phone-plans',
}
